"use client"

import { useState } from "react"
import { Link } from "react-router-dom"
import { ArrowRight, Factory, Bolt, Car, CircuitBoard } from "lucide-react"
import "./ProductsSection.css"
import placeholder from "../../images/placeholder.png"
import Energy from "../../images/Energy.jpg"
import Industrial from "../../images/Industrial.jpg"
import Automobile from "../../images/Automobile.png"

const ProductsSection = () => {
  const [activeCategory, setActiveCategory] = useState("automotive")

  const productCategories = [
    {
      id: "automotive",
      name: "Automobile Solutions",
      icon: <Car size={20} />,
      description: "Precision fluid management solutions for modern vehicle architectures",
      image: Automobile || placeholder, // Replace with actual image path or keep as null for placeholder
      products: [
        { name: "General Purpose Hoses Coolant / Air / Fuel ", link: "/products/753383" },
        { name: "Hoses for Engine Oil ", link: "/products/1A9017" },
        { name: "Temperature Hoses ", link: "/products/4B1B48" },
        { name: "Air Brake Nylone Tube", link: "/products/D80250" },
        // { name: "TPU tubes", link: "/products/0617B9" },
      ],
    },
    {
      id: "industrial",
      name: "Industrial Solutions",
      icon: <Factory size={20} />,
      description: "Heavy-duty fluid transfer for manufacturing and automation",
      image: Industrial||placeholder, // Replace with actual image path or keep as null for placeholder
      products: [
        { name: "TPU Coil", path: "/products/EA8E01" },
        { name: "TPU Rolls", path: "/products/3D4257" },
        { name: "Spray Hoses", path: "/products/D51AE8" },
        { name: "Temperature Hoses", path: "/products/4B1B48" },
        { name: "General Purpose Hoses Coolant / Air / Fuel", path: "/products/753383" },
      ],
    },
    {
      id: "energy",
      name: "Energy Solutions",
      icon: <Bolt size={20} />,
      description: "Transmission solutions for renewable energy infrastructure",
      image: Energy || placeholder, // Will use placeholder
      products: [
        { name: "FC-FCEV – Thermal Management", path: "/products/AAAAC6" },
        { name: "CNG Hose & Metal Tube", path: "/products/1B6047" },
        { name: "HVAC Lines & HVAC Assembly", path: "/products/1C2382" },
        { name: "Heater Hose / Coolant Pipes & Hoses", path: "/products/884EEA" },
        { name: "Brake Assembly & Clutch Assembly", path: "/products/1BDBDE" },
        { name: "Structural / Fabrication Parts", path: "/products/658447" },
      ],
    },
  ]

  const activeCategoryData = productCategories.find((cat) => cat.id === activeCategory)

  return (
    <section
      className="products-section-full-width"
      style={{
        position: "relative",
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        marginRight: "calc(-50vw + 50%)",
        backgroundColor: "#ffffff",
        // paddingTop:"1.25rem",
        padding: "1.25rem 0",
        overflow: "hidden",
      }}
    >
      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 2rem" }}>
        {/* Section Header */}
        <div
          style={{
            textAlign: "center",
            marginBottom: "3rem",
            maxWidth: "800px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <span
            style={{
              display: "block",
              fontSize: "0.75rem",
              fontWeight: "600",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#2563eb",
              marginBottom: "1rem",
            }}
          >
            TECHNOLOGY PORTFOLIO
          </span>
          <h2
            style={{
              fontSize: "2.25rem",
              fontWeight: "700",
              color: "#0f172a",
              marginBottom: "1.25rem",
              lineHeight: "1.2",
            }}
          >
            Advanced Transmission Solutions
          </h2>
          <p
            style={{
              fontSize: "1.125rem",
              color: "#64748b",
              lineHeight: "1.6",
            }}
          >
            Engineered fluid systems powering industries through precision dynamics and thermal management
          </p>
        </div>

        {/* Category Tabs */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: "1rem",
            marginBottom: "3rem",
            flexWrap: "wrap",
          }}
        >
          {productCategories.map((category) => (
            <button
              key={category.id}
              className={`tab-button ${activeCategory === category.id ? "active" : ""}`}
              onClick={() => setActiveCategory(category.id)}
              style={{
                display: "inline-flex",
                alignItems: "center",
                background: activeCategory === category.id ? "#2563eb" : "transparent",
                color: activeCategory === category.id ? "white" : "#334155",
                fontSize: "0.95rem",
                fontWeight: "500",
                padding: "0.75rem 1.5rem",
                borderRadius: "2rem",
                border: `1px solid ${activeCategory === category.id ? "#2563eb" : "#e2e8f0"}`,
                cursor: "pointer",
                transition: "all 0.25s ease",
              }}
              onMouseEnter={(e) => {
                if (activeCategory !== category.id) {
                  e.target.style.background = "rgba(59, 130, 246, 0.05)"
                  e.target.style.borderColor = "#3b82f6"
                  e.target.style.color = "#2563eb"
                }
              }}
              onMouseLeave={(e) => {
                if (activeCategory !== category.id) {
                  e.target.style.background = "transparent"
                  e.target.style.borderColor = "#e2e8f0"
                  e.target.style.color = "#334155"
                }
              }}
            >
              <span style={{ marginRight: "0.5rem", display: "flex" }}>{category.icon}</span>
              {category.name}
            </button>
          ))}
        </div>

        {/* Product Display */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: window.innerWidth > 1024 ? "1fr 1fr" : "1fr",
            gap: "4rem",
            marginBottom: "4rem",
          }}
        >
          {/* Product Info */}
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ marginBottom: "2rem" }}>
              <h3
                style={{
                  fontSize: "1.75rem",
                  fontWeight: "700",
                  color: "#0f172a",
                  marginBottom: "1rem",
                }}
              >
                {activeCategoryData?.name}
              </h3>
              <p
                style={{
                  fontSize: "1rem",
                  color: "#64748b",
                  lineHeight: "1.7",
                }}
              >
                {activeCategoryData?.description}
              </p>
            </div>

            <div style={{ marginBottom: "2.5rem" }}>
              <h4
                style={{
                  fontSize: "0.75rem",
                  fontWeight: "600",
                  letterSpacing: "0.1em",
                  textTransform: "uppercase",
                  color: "#2563eb",
                  marginBottom: "1.25rem",
                }}
              >
                PRODUCT LINES
              </h4>
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  display: "grid",
                  gridTemplateColumns: "1fr",
                  gap: "0.75rem",
                }}
              >
                {activeCategoryData?.products.map((product, index) => (
                  <li
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "0.75rem",
                      color: "#0f172a",
                      fontSize: "0.95rem",
                    }}
                  >
                    <CircuitBoard
                      style={{
                        color: "#2563eb",
                        flexShrink: 0,
                        marginTop: "0.125rem",
                      }}
                      size={16}
                    />
                    <Link
                      to={product.link}
                      style={{
                        color: "#2563eb",
                        textDecoration: "none",
                        transition: "all 0.2s ease",
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.textDecoration = "underline"
                        e.target.style.color = "#1d4ed8"
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.textDecoration = "none"
                        e.target.style.color = "#2563eb"
                      }}
                    >
                      {product.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ marginTop: "auto" }}>
              <Link
                to="/contact"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  background: "#2563eb",
                  color: "white",
                  fontWeight: "500",
                  fontSize: "0.95rem",
                  padding: "0.875rem 1.5rem",
                  borderRadius: "0.375rem",
                  textDecoration: "none",
                  transition: "all 0.25s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.background = "#1d4ed8"
                  e.target.style.transform = "translateY(-1px)"
                }}
                onMouseLeave={(e) => {
                  e.target.style.background = "#2563eb"
                  e.target.style.transform = "translateY(0)"
                }}
              >
                Request Specifications
                <ArrowRight size={16} style={{ marginLeft: "0.5rem" }} />
              </Link>
            </div>
          </div>

          {/* Product Visual */}
          <div style={{ position: "relative" }}>
            <div
              style={{
                position: "relative",
                height: "100%",
                minHeight: "320px",
                background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
                borderRadius: "1rem",
                overflow: "hidden",
              }}
            >
              {/* Product Image or Placeholder */}
              <img
                src={activeCategoryData?.image || placeholder}
                alt={activeCategoryData?.name}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  position: "absolute",
                  top: 0,
                  left: 0,
                }}
              />

              {/* Tech Pattern Overlay */}
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  backgroundImage: `linear-gradient(rgba(255,255,255,0.1), rgba(255,255,255,0.1))`,
                }}
              />

              {/* Tech Badge */}
              <div
                style={{
                  position: "absolute",
                  top: "1.5rem",
                  right: "1.5rem",
                  display: "inline-flex",
                  alignItems: "center",
                  background: "white",
                  color: "#2563eb",
                  fontSize: "0.75rem",
                  fontWeight: "500",
                  padding: "0.5rem 1rem",
                  borderRadius: "2rem",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                  zIndex: 1,
                }}
              >
                {activeCategoryData?.icon}
                <span style={{ marginLeft: "0.5rem" }}>Premium Solution</span>
              </div>
            </div>
          </div>
        </div>

        {/* Achievements Grid */}
        <div className="sku"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            gap: "2rem",
            paddingTop: "1rem",
            // borderTop: "1px solid #e2e8f0",
          }}
        >
          <div
            style={{
              textAlign: "center",
              padding: "2rem 1.5rem",
              backgroundColor: "#ffffff",
              borderRadius: "1rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              border: "1px solid #f1f5f9",
              transition: "all 0.3s ease",
              // cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)"
              e.currentTarget.style.boxShadow =
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"
              e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
            }}
          >
            <span
              style={{
                display: "block",
                fontSize: "2.5rem",
                fontWeight: "700",
                color: "#2563eb",
                marginBottom: "0.75rem",
                lineHeight: "1",
              }}
            >
              8500+
            </span>
            <span
              style={{
                fontSize: "0.875rem",
                color: "#64748b",
                fontWeight: "500",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              Listed SKUs
            </span>
          </div>

          <div
            style={{
              textAlign: "center",
              padding: "2rem 1.5rem",
              backgroundColor: "#ffffff",
              borderRadius: "1rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              border: "1px solid #f1f5f9",
              transition: "all 0.3s ease",
              // cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)"
              e.currentTarget.style.boxShadow =
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"
              e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
            }}
          >
            <span
              style={{
                display: "block",
                fontSize: "2.5rem",
                fontWeight: "700",
                color: "#2563eb",
                marginBottom: "0.75rem",
                lineHeight: "1",
              }}
            >
              9
            </span>
            <span
              style={{
                fontSize: "0.875rem",
                color: "#64748b",
                fontWeight: "500",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              Years of Excellence
            </span>
          </div>

          <div
            style={{
              textAlign: "center",
              padding: "2rem 1.5rem",
              backgroundColor: "#ffffff",
              borderRadius: "1rem",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
              border: "1px solid #f1f5f9",
              transition: "all 0.3s ease",
              // cursor: "pointer",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = "translateY(-4px)"
              e.currentTarget.style.boxShadow =
                "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)"
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = "translateY(0)"
              e.currentTarget.style.boxShadow = "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)"
            }}
          >
            <span
              style={{
                display: "block",
                fontSize: "2.5rem",
                fontWeight: "700",
                color: "#2563eb",
                marginBottom: "0.75rem",
                lineHeight: "1",
              }}
            >
              10+
            </span>
            <span
              style={{
                fontSize: "0.875rem",
                color: "#64748b",
                fontWeight: "500",
                textTransform: "uppercase",
                letterSpacing: "0.05em",
              }}
            >
              Global Markets
            </span>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductsSection